// ============================================================
// ProgressBar — replaces Bootstrap progress bars with tooltips
// Used in LiveData marking/attendance tables
// ============================================================
import React from 'react';

export interface ProgressSegment {
  percent: string | number;
  label: string; // tooltip text e.g. "Fully Marked: 1,234"
  colorClass: 'success' | 'warning' | 'danger' | 'primary' | 'info';
}

interface ProgressBarProps {
  segments: ProgressSegment[];
}

const colorMap: Record<string, string> = {
  success: '#05a34a',
  warning: '#fbbc06',
  danger: '#dc3545',
  primary: '#0b7db1',
  info: '#5970ca',
};

const ProgressBar: React.FC<ProgressBarProps> = ({ segments }) => {
  return (
    <div
      className="progress"
      style={{ height: 22, borderRadius: 4, overflow: 'hidden' }}
    >
      {segments.map((seg, idx) => {
        const width = Number(seg.percent) > 0 ? Number(seg.percent) : 0;
        return (
          <div
            key={idx}
            className={`progress-bar bg-${seg.colorClass}`}
            role="progressbar"
            title={seg.label}
            style={{ width: `${width}%`, background: colorMap[seg.colorClass] }}
            aria-valuenow={width}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            {width > 5 && <b style={{ fontSize: 11 }}>{width.toFixed(1)}%</b>}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
